import styled from 'styled-components';

const TitleWrap = styled.div`
    font-size: 1.125rem;
    height: 3.75rem;
    width: 100%;
    line-height: 3.75rem;
    text-align: center;
    border-bottom: 0.063rem solid ${props => props.theme.color};
`;

export default TitleWrap;
